module.exports = __webpack_public_path__ + "static/media/home.a457f513.svg";